import isEmpty from 'lodash/isEmpty';

import { IAutoPolicy } from '../../../interfaces';

import { diffPolicy } from './diffPolicy';

export function isStagedPolicyDirty(
  oldPolicy: IAutoPolicy,
  stagedPolicy: IAutoPolicy
) {
  const policyDiff = diffPolicy(oldPolicy, stagedPolicy);
  policyDiff?.id && delete policyDiff.id;
  policyDiff?.status && delete policyDiff.status;
  return !isEmpty(policyDiff);
}

export function isRunHealthCheck(
  oldPolicy: IAutoPolicy,
  stagedPolicy: IAutoPolicy
) {
  const policyDiff = diffPolicy(oldPolicy, stagedPolicy);
  const driverDiff = policyDiff?.details?.drivers;
  const vehicleDiff = policyDiff?.details?.vehicles;

  return !isEmpty(driverDiff) || !isEmpty(vehicleDiff);
}
